import LegalPage from '../components/LegalPage';
import { site } from '../config';

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      intro={`This policy explains how ${site.domain} ("we", "us") collects, uses, and protects information when you use this website, live chat, or phone support.`}
    >
      <h2>Information we collect</h2>
      <p>
        When you fill in a form, chat, or call, we may collect your name, phone number, email address, and details
        about the problem you need help with. We also collect basic technical data such as IP address, browser type,
        device type, and pages visited.
      </p>

      <h2>How we use it</h2>
      <p>
        We use your information to answer your request, provide support, follow up on open issues, keep the website
        secure, and improve our service. We do not sell your personal information.
      </p>

      <h2>Third-party services</h2>
      <p>
        Live chat and analytics are provided by third-party services that process limited data on our behalf and
        under their own privacy terms.
      </p>

      <h2>Cookies</h2>
      <p>
        We use cookies and similar technologies to keep chat sessions working and to understand how the website is
        used. You can block cookies in your browser, though some features may stop working.
      </p>

      <h2>Retention and security</h2>
      <p>
        We keep personal information only as long as needed for the purposes above and protect it with reasonable
        safeguards. No method of transmission over the internet is completely secure.
      </p>

      <h2>Your choices</h2>
      <p>
        You may ask us to access, correct, or delete your personal information by emailing{' '}
        <a href={`mailto:${site.email}`}>{site.email}</a>.
      </p>
    </LegalPage>
  );
}
